<div class="row my-page">
    <div class="m-b-25 br-0 head-component">
        <div class="col-10 p-l-20 m-0 for-fixed-component br-0 head-component card">
            <div class="col-12 pl-0 card-body">
                <div class="float-left col-12 card-header">
                    <h5 class="m-0 head-main-component" *ngIf="isSelfassessmentTab; else defaultNav">
                        <span (click)="navigateToMyPage()" [routerLink]="['/user/my-page/']">
                            {{ 'lang.userMenu.myPage' | translate}}</span>
                        <i class="mdi mdi-chevron-right"></i>
                        <span (click)="navigateToSurvey()" [routerLink]="['/user/my-page/self-assessment', {currentFilter: surveyFilter.ByAppraisee}]">
                            {{'lang.user.estimate.my' | translate}}
                        </span>
                        <i class="mdi mdi-chevron-right" *ngIf="isSurveyOpen"></i>
                        <span *ngIf="isSurveyOpen">
                            {{surveyProcessName}}
                        </span>
                    </h5>

                    <div class="nav float-left">
                        <span (click)="navigateToMyPage()" [routerLink]="['/user/my-page']" routerLinkActive="active-navigation"
                            [routerLinkActiveOptions]="{exact: true}">
                            {{ 'lang.userMenu.navigation.assignRespondents' | translate}}
                        </span>
                        <span (click)="navigateToSurvey()" [routerLink]="['/user/my-page/self-assessment', {currentFilter: surveyFilter.ByAppraisee}]"
                            routerLinkActive="active-navigation">
                            {{'lang.user.estimate.my' | translate}}
                        </span>
                        <!-- TODO: new report-->
                        <span (click)="navigateToMyPage()" [routerLink]="['/user/my-page/my-reports']" routerLinkActive="active-navigation"
                            [routerLinkActiveOptions]="{exact: true}">
                            {{ 'lang.userMenu.navigation.myReports' | translate}}
                        </span>
                    </div>
                    <div *ngIf="isReportOpened" class="nav justify-content-end download-btn-group" >
                        <button class="btn btn-outline download-pdf m-r-15" (click)="navigateToIndividualReport()">{{ getButtonTitle() | translate }}</button>
                        <div class="btn-group" dropdown>
                            <button class="btn btn-outline download-pdf dropdown-toggle" [disabled]="isPdfDownloadingInProgress"
                                id="dropdownDownloadButton" dropdownToggle aria-controls="dropdown-button">
                                {{ 'lang.reporting.downloadReport' | translate }}<span class="caret"></span></button>
                            <div role="menubar" class="dropdown-menu dropdown-menu-right" id="dropdown-button" *dropdownMenu
                                aria-labelledby="dropdownDownloadButton">
                                <a class="dropdown-item" (click)="downloadIndividualPdf()">{{ 'lang.reporting.downloadIndividualReport' | translate }}</a>
                                <a class="dropdown-item" (click)="downloadSummaryPdf()">{{ 'lang.reporting.downloadSummaryReport' | translate }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="p-l-25" [ngClass]="(!isSelfassessmentTab)?'col-9':'col-12'">
        <router-outlet></router-outlet>
    </div>
    <div *ngIf="!isSelfassessmentTab" class="col-3 p-l-10 right-block">
        <div class="bg-none pl-0 m-b-20">
            <div class="card-body p-0">
                <div class="row info-panel">
                    <div class="col-1">
                        <i class="mdi mdi-information-outline"></i>
                    </div>
                    <div class="col-10 pr-0">
                        {{ 'lang.user.userHelpMypage' | translate}}
                    </div>
                </div>
            </div>
        </div>
        <div class="grow-container"></div>
        <app-links-card [links]="'lang.links.documents.my_page' | translate"></app-links-card>
    </div>
</div>
<ng-template #defaultNav>
    <h5 class="m-0 head-main-component">
        {{ 'lang.userMenu.myPage' | translate}}
        <i class="mdi mdi-chevron-right" style="visibility: hidden"></i>
    </h5>
</ng-template>